import { useEffect, useState } from 'react';

import SearchIcon from 'icons/SearchIcon';

/**
 * Compact, icon-only version of the navbar search. Rendered in place of the
 * full search input when the top nav runs out of horizontal space (e.g. many
 * apps enabled) so that right-side items like Settings and the profile menu
 * don't get pushed off-screen. Clicking it opens the command palette.
 */
const CollapsedSearchButton = ({ onClick }: { onClick: () => void }) => {
  const [isMac, setIsMac] = useState(true);
  useEffect(() => {
    setIsMac(/Mac|iPhone|iPad|iPod/.test(navigator.platform) || /Mac/.test(navigator.userAgent));
  }, []);

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Search"
      title="Search"
      className="flex h-9 items-center gap-2 rounded-lg bg-neutral-100 px-3 text-neutral-600 transition-colors hover:bg-neutral-200"
    >
      <SearchIcon className="h-4 w-4" />
      <span className="rounded border border-neutral-300 bg-neutral-200/60 px-1.5 py-0.5 text-[10px] font-medium text-neutral-500">
        {isMac ? '⌘K' : 'Ctrl+K'}
      </span>
    </button>
  );
};

export default CollapsedSearchButton;
